import {Time} from "@angular/common";
import {User} from "./user";
import {ProtestInfo} from "./protest";
import {Timestamp} from "rxjs";
import {InputError} from "./security";

export interface AttorneyInfoResponse {
  fileInfoList: FileInfo[],
  daysRemaining: number,
  attorneyInfo?: User,
  intervenorCompanyNameList: string[],
  protestInfo: ProtestInfo,
  user_Info: User,
  whole_Doc_Info_Map: WholeDocInfo[],
  caseDocketNotFound: boolean,
  inputErrors: InputError[]
}

export interface FileInfo {
  a_No: string,
  attorney_Note: string,
  case_access_request_status: string,
  comments: string,
  company_Address: string,
  company_Name: string,
  docTypeName: string,
  doc_Type_Id: number,
  fileAlert: string,
  fileName: string,
  file_Id: number,
  file_identifier: string,
  filler: string,
  indexNum: number,
  isAttorneyNoteEdited?: string,
  isCommentEdited?: string,
  is_Confidential: string,
  is_Intervene_Approved: boolean,
  is_Visible: string,
  originalSubmissionDate: string,
  po: string,
  sortableSubmissionDate: Date;
  submission_Date: string,
  submitter_Role: string,
  submitter_User_Id: string,
  time_stamp: Timestamp<Time>,
  transient_Attorney_Note_Date: string,
  transient_Comments: string,
  transient_Comments_Date: string,
  transient_Date: string,
  transient_Note: string,
  transient_Time: Time
}

export interface WholeDocInfo {
  case_Type: string,
  doc_Type_Desc: string,
  doc_Type_Id: number,
  filing_Order: number,
  role: string
}

export interface SubmitNewDocDTO {
  typeofdocument: string,
  isDocConfidential: boolean,
  intervenorCompanyName?: string,
  protestId: string,
  docId: number,
  user_Id: string,
  comments: string,
  po: boolean,
  intervenorEmailAddress?: string,
  street?: string,
  address1?: string,
  address2?: string,
  city?: string,
  state?: string,
  country?: string,
  zipCode?: string,
  company_Address?: string,
  company_Name?: string,
  docDescFiller?: string,
  user_Role: string,
  docketEntryNumber: number,
  attorney_note: string,
  isInterveneApproved?: boolean,
  caseAccessRequestStatus?: string,
  listOfProtestIds?: string,
  consolidatedBNumber?: string,
  consolidatedANumber?: string,
  docketEntryTitle: string,
  inputErrors: InputError[];
}

export interface AttorneyNote {
  fileId: string;
  note: string;
}

export interface AttorneyNoteResponse {
  currentTime: string;
  note: string;
  addAttorneyNote: AttorneyNote;
  inputErrors: InputError[];
}

export interface DMNumberCheckResponse {
  isExists: boolean;
}

export interface CompleteBtnData {
  text : CaseCompleteState;
  protestInfo : ProtestInfo;
}

export interface CompleteAndDMResponse {
  error: string,
  errorId: string,
  isSuccess: boolean
  protestInfo: ProtestInfo
}

export interface ValidateDmInfoResponse {
  isExists: boolean
}

export interface VerifyDmInfoResponse {
  hasOpenChild: boolean,
  isEqual: boolean,
  protestInfoList: ProtestInfo[],
  dbDMNumber: string
}

export enum CaseCompleteState {
  NONE = "NONE",
  Complete = "Complete",
  Final = "Final Record",
  Pending = "Pending Verification",
  Verify = "Verify DM"
}

export interface CaseAccessResponse {
  a_No: string,
  file_InfoList: FileInfo[]
}

export interface DocketDocumentInfoResponse {
  type_Of_Doc: string,
  file_InfoList: FileInfo[],
  protestInfo: ProtestInfo,
  a_No: string,
  caseStatus: string,
  user_Info: User,
  viewCaseDocketFileInfo: CaseDocketFileInfo,
  PO: string,
}

export interface CaseDocketFileInfo {
  protestId: string,
  submissionDate: string,
  doc_Type_Id: number,
  fileAlert: string
}

export interface JoinValidateResponse {
  response: string;
}

export interface EditProtestInfoResponse {
  newValue?: string;
  newValue2?: string;
  listOfBNumbers: string;
  oldValue?: string;
  aNum: string;
  agency_tier1: string;
  agency_tier2: string;
}

export interface JoinCaseResponse {
  editProtestInfo: EditProtestInfoResponse;
  protestInfo: ProtestInfo;
  isSuccess: boolean;
}
